import { render, staticRenderFns } from "./CampaignItem.vue?vue&type=template&id=4d1c48ae&lang=html&"
import script from "./CampaignItem.vue?vue&type=script&lang=js&"
export * from "./CampaignItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports